export default class AlertsActionsController {
    /** @ngInject */
    constructor(Loader, AlertsActionsApi, ToastService, $rootScope, $timeout) {
        this.Loader = Loader;
        this.ToastService = ToastService;
        this.AlertsActionsApi = AlertsActionsApi;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.isSupported = false;
        this.currentAlertsActions = null;
        this.alertsActions = [];

        this.getAlertsActionsList();
    }

    getAlertsActionsList() {
        this.Loader.show();

        this.AlertsActionsApi.getList().then((data) => {
            this.alertsActions = data['alerts-actions'] || [];
            this.Loader.hide();
        });
    }

    getCurrentRule({ rule }) {
        this.Loader.show();

        this.currentAlertsActions = false;
        this.$timeout(() => {
            this.currentAlertsActions = rule;
            this.Loader.hide();
        }, 500);
    }

    resetAlertsActionsCurrent({ rule }) {
        if (rule) {
            this.currentAlertsActions = null;
        }
    }

    removeAlertsActions(id) {
        const removeId = id;

        this.Loader.show();

        this.AlertsActionsApi.remove(removeId).then((response) => {
            this.alertsActions = this.alertsActions.filter(item => item.id !== response.id);

            this.currentAlertsActions = null;

            this.Loader.hide();

            this.ToastService.show(this.ToastService.createSimple({
                text: 'Rule deleted',
                position: 'bottom right'
            }));

            this.$rootScope.$applyAsync();
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions.controller.js